// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"Title_titleContainer__1PW0v","mobileTitle":"Title_mobileTitle__1KLBk"};